<template minapp='mpx' xlang='wxml'>
  <es-popup 
  closeable="{{false}}"
  show="{{option.show}}" 
  wx:style="{{style}}"
  >
    <view class="es-dialog custom-class">
      <!-- 标题栏 -->
      <view class="es-dialog__header custom-header">
        <block wx:if="{{option.title}}">{{option.title}}</block>
        <slot wx:else name='title'></slot>
      </view>
      <!-- 内容栏 -->
      <view class="es-dialog__body custom-body" wx:class="{{classnames}}">
        <block wx:if="{{option.message}}">{{option.message}}</block>
        <slot wx:else name="content"></slot>
      </view>
      <!-- 操作栏 -->
      <view class="es-dialog__footer custom-footer">
        <es-button 
        block
        bind:click="handleAction('cancel')"
        class='es-dialog__button custom-cancel'
        custom-class='es-dialog__cancel'
        wx:if="{{option.showCancelButton}}"
        >
        {{option.cancelButtonText}}
        </es-button>

        <es-button wx:class="{{showClass? 'es-dialog__buttonS':''}}"
        block
        bind:click="handleAction('confirm')"
        class="es-dialog__button es-dialog__border-left custom-confirm"
        custom-class='es-dialog__confirm'
        wx:if="{{option.showConfirmButton}}"
        >
        {{option.confirmButtonText}}
        </es-button>
      </view>
    </view>
    
  </es-popup>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  const props = {
    title: String,
    message: String,
    algin: {
      type: String,
      value: 'center'
    },
    show: {
      type: Boolean,
      value: false
    },
    width: {
      optionalTypes: [Number],
      type: String,
      value: '320px'
    },
    showConfirmButton: {
      type: Boolean,
      value: true
    },
    showCancelButton: {
      type: Boolean,
      value: false
    },
    confirmButtonText: {
      type: String,
      value: '确定'
    },
    cancelButtonText: {
      type: String,
      value: '取消'
    },
    showClass: {
      type: Boolean,
      value: true
    },
    beforeClose: null
  }

  const defaultConfig = {
    show: false,
    algin: 'center',
    title: '',
    message: '',
    width: '320px',
    beforeClose: null,
    showConfirmButton: true,
    showCancelButton: false,
    cancelButtonText: '取消',
    confirmButtonText: '确定'
  }

  const createWatch = option => {
    return Object.keys(props).reduce((pre, key) => {
      pre[key] = {
        immediate: true,
        handler(val) {
          this.setOption({ [key]: val })
        }
      }
      return pre
    }, option || {})
  }

  createComponent({
    props,
    classes: ['custom-header', 'custom-body', 'custom-footer', 'custom-confirm', 'custom-cancel'],
    computed: {
      style() {
        return {
          width: this.option.width
        }
      },
      classnames() {
        return {
          [`es-dialog__body--${this.option.algin}`]: true
        }
      }
    },

    watch: createWatch(),

    data: {
      option: { ...defaultConfig }
    },

    methods: {
      setOption(option) {
        this.option = { ...this.option, ...option}
      },
      // cancel | confirm
      close(action) {
        this.option.show = false
        this.$nextTick(() => {
          this.$trigger('close', action)
        })
      },

      // cancel | confirm
      handleAction(action) {
        this.$trigger(action, this)

        if (typeof this.option[action] === 'function') {
          this.option[action](action)
        }

        if (this.option.beforeClose) {
          return new Promise((resolve, reject) => {
            this.option.beforeClose( action, resolve, reject )
          }).then(() => {
            this.close(action)
          })
        }

        this.close(action)
      }
    }
  })
</script>

<style lang='stylus' src='./style.styl'></style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-popup': '../popup/index',
      'es-button': '../button/index'
    }
  }
</script>

